/**
 * Stat Counter
 */
export default () => {

    class AnimatedCounter {

        constructor(element, targetClass) {
            this.element = element;
            this.targetClass = targetClass;
            this.observer();
            this.init();
        }
    
        init() {
            const statBlocks = [...this.element.getElementsByClassName(this.targetClass)];
            statBlocks.forEach((stat) => {
                this.observer.observe(stat);
            });
        }
    
        observer() {
            this.observerOptions = { root: null, rootMargin: "0px 0px", threshold: 0 };
            this.observer = new IntersectionObserver((elements) => {
                elements.forEach((element) => {
                    if (element.isIntersecting) {
                        const value = parseFloat(element.target.dataset.animateValue.replace(/,/g, ""));
                        const decimals = (Math.floor(value) === value) ? 0 : value.toString().split(".")[1].length || 0; 
                        this.increment(element.target, value, decimals);
                    }
                });
            }, this.observerOptions);
        }
    
        increment(element, end, decimals) {
            const start = 0;
            const duration = 3000;
    
            let startTimestamp = null;
            const step = (timestamp) => {
                startTimestamp = startTimestamp ? startTimestamp : timestamp;
                const progress = (timestamp - startTimestamp) / duration;
                const easingProgress = Math.min(1 - Math.pow(1 - progress, 3), 1);
                const rawNumber = Math.abs(easingProgress * (end - start) + start);
                const formattedNumber = rawNumber.toLocaleString("en-GB", {
                    minimumFractionDigits: decimals,
                    maximumFractionDigits: decimals
                });
                element.innerHTML = formattedNumber;
                if (easingProgress < 1) {
                    window.requestAnimationFrame(step);
                }
            };
    
            window.requestAnimationFrame(step);
        }
    }

    const dataModules = [...document.getElementsByClassName(`js-stat-block__stat`)];
    dataModules.forEach((element) => {
        const shouldAnimate = element.dataset.animateStat;
        if (shouldAnimate === 'true') {
            new AnimatedCounter(element, `js-stat-block__stat__value`);
        }
    });
}